import validator from "validator";


export const validateEmail = (email) => {

	var result = validator.isEmail(email);

	return result;
}